import { render } from "./Level.vue?vue&type=template&id=2a2aaa8e&scoped=true"
import script from "./Level.vue?vue&type=script&lang=js"
export * from "./Level.vue?vue&type=script&lang=js"

import "./Level.vue?vue&type=style&index=0&id=2a2aaa8e&lang=scss&scoped=true"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2aaa8e"],['__file',"src/components/level/Level.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a2aaa8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a2aaa8e', __exports__)) {
    console.log('reload')
    api.reload('2a2aaa8e', __exports__)
  }
  
  module.hot.accept("./Level.vue?vue&type=template&id=2a2aaa8e&scoped=true", () => {
    console.log('re-render')
    api.rerender('2a2aaa8e', render)
  })

}


export default __exports__